import type { UserAttributes } from '@cobliteam/api-lib';
import type { UserData } from '@cobliteam/common-types';

/** Mesmos defaults de `getInactiveFleetFallbackUserData` — conta sem dispositivos, "antiga". */
const FALLBACK_USER_ATTRIBUTES: UserAttributes = { numberOfDevices: 0, creationDate: 0, ageInDays: 0 };

type ResolveLdUserAttributesInput = {
  userData: UserData | undefined;
  /** A query do `getUserData` terminou em erro (não está mais em voo). */
  hasUserDataFailed: boolean;
};

/**
 * Atributos de usuário para o `ldClient.identify`, ou `null` para esperar.
 *
 * O `FeatureFlagsProvider` segura o app no splash até o identify resolver — de propósito: flags
 * avaliadas no contexto anônimo fazem o `PrivateRoute` mandar rotas gated para /404 no cold boot.
 * Mas esperar **indefinidamente** por `userData` prende o app para sempre quando o `getUserData`
 * rejeita: numa sessão de frota inativa os resolvers do janus dão 403 e o transporte devolve
 * `data: null`, que a `api-lib` transforma em rejeição. Como este provider envolve o
 * `DashboardProvider`, o fallback de frota inativa que existe lá embaixo nunca chega a montar.
 *
 * Então: espera enquanto a query está em voo, e destrava com defaults seguros quando ela falha.
 */
const resolveLdUserAttributes = ({ userData, hasUserDataFailed }: ResolveLdUserAttributesInput): UserAttributes | null => {
  if (userData) return userData.userAttributes;
  return hasUserDataFailed ? FALLBACK_USER_ATTRIBUTES : null;
};

export { FALLBACK_USER_ATTRIBUTES };
export default resolveLdUserAttributes;
